<template lang="pug">
    .facilities(v-if="content")
        .page__wr.facilities__wr
            ul.facilities__nav
                li.facilities__nav-item(v-for="(item, index) in content.nav" :key="index" :class="{'facilities__nav-item--active': index == content.nav.length-1}")
                    router-link(:to="item.link") {{ item.name }}
            .facilities__container
                h2.facilities__headline {{ content.subtitle }}
                .facilities__container-menu
                    .facilities__container-menu-item(v-for="(item, index) in content.facilitiesCategory" :key="index"  :data-id="item.id"  :class="{'facilities__container-menu-item--active': index == content.facilitiesCategory.length-1}" v-on:click="addActiveClass($event)") {{ item.name }}
            .facilities__list
                router-link.facilities__list-item(v-for="(item, index) in facilities" :key="index" :to="item.link")
                    .facilities__list-item-img-wr
                        img.facilities__list-item-img(:src="item.image.path" :alt="item.image.name" v-show="!imgHide")
                    .facilities__list-item-name {{ item.name }}

</template>

<script>
    import EventBus from '@/eventBus';
    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

    import '@/components/facilities/facilities.styl';
    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';

    export default {
        name: 'Facilities',

        mixins: [AjaxHelpersVue],

        data() {
            return {
                content: null,
                facilities: null,
                imgHide: true,
                objImages: [],
            }
        },

        components: {
            SvgIcon,
        },

        created() {
            // Загрузка данных для страницы
            this.$nextTick(() => {
                // this.request(this.$router.currentRoute.path);
            });

            EventBus.$on('imgLoaded', (res) => {
                this.imgHide = res;
            });
        },

        mounted() {
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                // экземпляр компонента доступен как `vm
                EventBus.$emit('pagePreloaderShow');
                vm.scrollbarCheck();
                setTimeout(() => {
                    EventBus.$emit('setMenuTopActiveClass', to.path);
                    vm.request(to.path);
                }, 50);
            })
        },

        beforeRouteUpdate(to, from, next) {
            EventBus.$emit('pagePreloaderShow');
            this.scrollbarCheck();
            setTimeout(() => {
                EventBus.$emit('setMenuTopActiveClass', to.path);
                this.request(to.path);
                next();
            }, 50);
        },

        methods: {
            request(url) {
                this.req('FacilitiesPage:getFacilitiesPage', {url}, res => {
                    this.content = res.content;
                    EventBus.$emit('pagePreloaderHide');
                    this.$nextTick(() => {
                        let id = $('.facilities__container-menu-item--active').attr('data-id');
                        let data = {
                            categoryId: id
                        };
                        this.requestData('FacilitiesPage:getFacilitiesInCategory', data).then((res)=> {
                            this.facilities = res.facilitiesList;
                            for(let i = 0; i < this.facilities.length; i++) {
                                this.objImages = this.objImages.concat({loaded: false, url: this.facilities[i].image.path});
                            }
                            this.checkImgLoading(this.objImages);
                            $('.facilities__list').css('opacity', '1');
                            this.$nextTick(() => {
                                this.checkOverflow(url);
                            })
                        });
                    });
                });
            },
            addActiveClass(event) {
                let elem = event.target;
                $('.facilities__container-menu-item').removeClass('facilities__container-menu-item--active');
                $('.facilities__list').css('opacity', '0');
                let id = $(elem).attr('data-id');
                let data = {
                    categoryId: id
                };
                this.facilities = null;
                this.requestData('FacilitiesPage:getFacilitiesInCategory', data).then((res)=> {
                    this.objImages = [];
                    $(elem).addClass('facilities__container-menu-item--active');
                    this.facilities = res.facilitiesList;
                    for(let i = 0; i < this.facilities.length; i++) {
                        this.objImages = this.objImages.concat({loaded: false, url: this.facilities[i].image.path});
                    }
                    this.checkImgLoading(this.objImages);
                    $('.facilities__list').css('opacity', '1');
                });
            }
        }
    }
</script>
